
import * as bunnyRuntime$fiGHK5IV4n from '/app/node_modules/@nuxt/image/dist/runtime/providers/bunny'
import * as weservRuntime$vip3FthLRZ from '/app/node_modules/@nuxt/image/dist/runtime/providers/weserv'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "bunny",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['bunny']: { provider: bunnyRuntime$fiGHK5IV4n, defaults: {"baseURL":""} },
  ['weserv']: { provider: weservRuntime$vip3FthLRZ, defaults: {"baseURL":"https://s3.eu-central-2.wasabisys.com/undefined/"} }
}
        